import { FC, useMemo } from "react";
import { DateTime } from "luxon";
import { Tooltip } from "@radix-ui/themes";

interface RelativeTimeProps {
  timestamp: number;
}

export const RelativeTime: FC<RelativeTimeProps> = ({ timestamp }) => {
  const dt = useMemo(() => DateTime.fromMillis(timestamp), [timestamp]);
  const relative = dt.toRelative() ?? "unknown";
  const absolute = dt.toLocaleString(DateTime.DATETIME_FULL_WITH_SECONDS);

  return (
    <Tooltip content={absolute}>
      <span style={{ cursor: "default" }}>{relative}</span>
    </Tooltip>
  );
};

export const formatDuration = (startedAt: number, completedAt?: number): string => {
  if (!completedAt) return "running...";
  const ms = completedAt - startedAt;
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (minutes < 60) return `${minutes}m ${remainingSeconds}s`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};
